import Vue from 'vue'
import Router from 'vue-router'
import Caution from '@/components/Caution'
import Top from '@/components/Top'
import Search from '@/components/Search'
import ImageView from '@/components/ImageView'
import Forbidden from '@/components/Forbidden'
import Error from '@/components/Error'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Caution
    },
    {
      path: '/tomamu',
      name: 'Caution',
      component: Caution
    },
    {
      path: '/tomamu/top',
      name: 'Top',
      component: Top
    },
    {
      path: '/tomamu/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/tomamu/images/:fileName',
      name: 'ImageView',
      component: ImageView,
      props: true
    },
    {
      path: '/tomamu/forbidden',
      name: 'Forbidden',
      component: Forbidden
    },
    {
      path: '/error/:messageId',
      name: 'Error',
      component: Error,
      props: true
    },
    {
      path: '*',
      name: 'NotFound',
      component: Error,
      props: {
        messageId: 'resource_not_found'
      }
    }
  ]
})
